import graphqlRequest from "Services/assignment/assignmentRequest";
import {
  ENTITY_TYPE,
} from "Services/assignment/constants";
import ADD_BATCH_ASSIGNMENTS from "./graphql";

export async function addBatchAssignments(payload) {
  const {entityIdList, entityType=ENTITY_TYPE.STUDENT, assignmentType, manifest, assignor, dateFrom, dateTo, periodId, schoolYear, parentId } = payload
  const response = await graphqlRequest(ADD_BATCH_ASSIGNMENTS, {
    entityIdList,
    entityType,
    assignmentType,
    manifest,
    assignor,
    dateFrom,
    dateTo,
    periodId,
    schoolYear,
    parentId
  });
  return response
}
